import * as React from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';

const SentryErrorBoundary = (props: Props) => (
	<Sentry.ErrorBoundary fallback={({ error, componentStack }) => getFallback(error, componentStack)} showDialog>
		{props.children}
	</Sentry.ErrorBoundary>
);

export default SentryErrorBoundary;

interface Props {
	children: React.ReactNode;
}

const getFallback = (error: unknown, componentStack: string) => (
	<StyledArticle>
		<h4>Something went wrong.</h4>
		<details>
			<div>{error.toString()}</div>
			<div>{componentStack}</div>
		</details>
	</StyledArticle>
);

const StyledArticle = styled.article`
	margin: auto 5%;

	h4 {
		text-align: center;
	}
`;
